import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        success:
          "border-transparent bg-success text-success-foreground hover:bg-success/80",
        info:
          "border-transparent bg-info text-info-foreground hover:bg-info/80",
        warning:
          "border-transparent bg-warning text-warning-foreground hover:bg-warning/80",
        rose:
          "border-transparent bg-rose text-rose-foreground hover:bg-rose/80",
        accent:
          "border-transparent bg-accent text-accent-foreground hover:bg-accent/80",
        muted:
          "border-transparent bg-muted text-muted-foreground hover:bg-muted/80",
        teal:
          "border-transparent bg-teal text-teal-foreground hover:bg-teal/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
